module.exports = __webpack_public_path__ + "static/year2013-4904a9b863e47411aa56f199f5a02def.jpg";